// extracted by mini-css-extract-plugin
export var loadingSpinner = "Spiner-module--loadingSpinner--d0bc4";
export var loadingSpinnerWrapper = "Spiner-module--loadingSpinnerWrapper--9a7ba";
export var reversed = "Spiner-module--reversed--78c46";